const mainImg = '/images/components/InspectionBanner/Toyota_Rav4_Side 1.png';
const mobileMainImg = '/images/components/InspectionBanner/Toyota_Rav4_Mobile_Slide_1.png';

const mockData = {
  headline: "We make great cars awesome.\r\nHere's how.",
  mainText:
    'With the right attention, pre-loved can feel good as new.\r\nEvery car we sell has been put through its paces in our state-of-the-art test facility, and certified by a team of mechanical and technical experts, so you can buy with confidence.',
  img: mainImg,
  mobileImg: mobileMainImg,
  benefitList: [
    {
      id: 1,
      logo: '/images/components/300pointInspection/CarMechanicInSpection.svg',
      title: 'No stone unturned',
      smallTitle: 'A checklist developed by experts',
      bodyText:
        'Every car is rigorously tested against our comprehensive, custom checklist, developed by industry experts with decades of experience at leading car manufacturers.',
    },
    {
      id: 2,
      logo: '/images/components/300pointInspection/Computer.svg',
      title: 'A scientific approach to inspection',
      smallTitle: 'Our state-of-the-art test facility',
      bodyText:
        'All cars are examined and rigorously tested at our purpose-built 30,000 sqm facility. Its advanced diagnostics equipment includes laser-wheel alignment and precision-engineered suspension and brake test lanes. For the best performance, we only use Mobil oils.',
    },
    {
      id: 3,
      logo: '/images/components/300pointInspection/MechanicList.svg',
      title: 'Issues identified and resolved',
      smallTitle: 'A dedicated professional team',
      bodyText:
        'Our fully certified team have the mechanical and technical skills needed to identify and resolve a wide range of potential issues, across all makes and models.',
    },
  ],
};

export default mockData;
